/**
 * Creates cache management actions for the store
 * @param {Function} set - Zustand set function
 * @param {Function} get - Zustand get function
 * @returns {Object} - Cache actions
 */
export const createCacheActions = (set, get) => ({
  /**
   * Clear a specific preference from cache
   * @param {string} key - Preference key
   */
  clearPreference: (key) => {
    set((state) => {
      const newPreferences = { ...state.preferences };
      delete newPreferences[key];
      return { preferences: newPreferences };
    });
  },

  /**
   * Clear all preferences from cache
   */
  clearAllPreferences: () => {
    set({ preferences: {}, errors: {}, initialized: false });
  },

  /**
   * Check if a preference is currently loading
   * @param {string} key - Preference key
   * @returns {boolean}
   */
  isLoading: (key) => {
    return get().loading[key] || false;
  },

  /**
   * Get error for a specific preference
   * @param {string} key - Preference key
   * @returns {string|null}
   */
  getError: (key) => {
    return get().errors[key] || null;
  },

  /**
   * Synchronous get from cache only (for existing code compatibility)
   * @param {string} key - Preference key
   * @returns {any|undefined} - Cached value or undefined
   */
  getCached: (key) => {
    return get().preferences[key];
  },

  /**
   * Update cache without API call (useful for temporary state)
   * @param {string} key - Preference key
   * @param {any} value - Value to cache
   */
  updateCache: (key, value) => {
    set((state) => ({
      preferences: { ...state.preferences, [key]: value },
    }));
  },
});
